import React, {useEffect, useLayoutEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';

import {getModelForResourceType} from 'resources/modelRegistry';
import {BasicCourseCard} from 'client/components/CourseCard/CourseCard.react';

import {Pagination} from '@albert-io/atomic';

export default function IndiePracticePanel({className, hidden, id, subjects, ...rest}) {
  const [page, setPage] = useState(1);
  const pageSize = 12;

  const subjectsToShow = subjects.sortBy((subject) => subject.getName().toLowerCase());

  const start = page * pageSize - pageSize;
  const end = start + pageSize;

  const totalPages = Math.ceil(subjectsToShow.size / pageSize);

  const paginatedSubjectsToShow = subjectsToShow.slice(start, end);

  // Clear pagination if number of subejcts changes, for instance due to keyword search
  useLayoutEffect(() => {
    setPage(1);
  }, [subjects]);

  useEffect(() => {
    if (hidden) {
      setPage(1);
    }
  }, [hidden]);

  return (
    <section
      className={classnames('ip__cards-wrapper u-width_100pc', className)}
      hidden={hidden}
      {...rest}
    >
      <ul className='ip__cards u-width_100pc u-list-style_none u-pad_0 u-mar-t_0 u-mar-lr_0'>
        {paginatedSubjectsToShow.map((subject) => {
          return (
            <li key={subject.getId()}>
              <BasicCourseCard
                className='ip__cards__card'
                subject={subject}
                to={`/${subject.getUrlSlug()}`}
              />
            </li>
          );
        })}
      </ul>
      {subjectsToShow.size > pageSize ? (
        <Pagination
          align='center'
          aria-controls={id}
          className='u-mar-t_5'
          defaultPage={page}
          key={page}
          onChange={(val) => setPage(val)}
          totalPages={totalPages}
        />
      ) : null}
    </section>
  );
}

IndiePracticePanel.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool,
  id: PropTypes.string,
  subjects: ImmutablePropTypes.listOf(PropTypes.instanceOf(getModelForResourceType('subject_v2')))
};
